export default __webpack_public_path__ + "static/Washington-0a69c232bd58c4def23d36f1c3c62b26.webp";